module.exports = __webpack_public_path__ + "img/vision-pattern.7c871c8f.png";